export enum CoordinationContainerTypeEnum {
    CONTAINER_TYPE_UNKNOWN = 'CONTAINER_TYPE_UNKNOWN',
    CONTAINER_TYPE_COORDINATION = 'CONTAINER_TYPE_COORDINATION',
    CONTAINER_TYPE_EASA = 'CONTAINER_TYPE_EASA',
    CONTAINER_TYPE_NOEASA = 'CONTAINER_TYPE_NOEASA',
    CONTAINER_TYPE_PUBLIC = 'CONTAINER_TYPE_PUBLIC',
    CONTAINER_TYPE_RESPONSIBILITY = 'CONTAINER_TYPE_RESPONSIBILITY',
}